import { useAccount } from 'src/providers/account/hook/useAccount';

export const useIsAdmin = () => {
  const { user } = useAccount();

  // Check if user has administrator role
  return user?.role === 'admin' || user?.role === 'company_admin';
};

// Hook to check if user is Admin (highest level)
export const useIsSuperAdmin = () => {
  const { user } = useAccount();
  return user?.role === 'admin';
};

// Hook to check if user is Company Admin
export const useIsCompanyAdmin = () => {
  const { user } = useAccount();
  return user?.role === 'company_admin';
};

// Hook to get current user role
export const useCurrentUserRole = () => {
  const { user } = useAccount();
  return user?.role;
};

// Hook to check if user can view/modify another user
export const useCanManageUser = (targetUserRole: string) => {
  const currentRole = useCurrentUserRole();

  // Only Admins can view and modify all users
  if (currentRole === 'admin') {
    return true;
  }

  // Company Admins can only see User and Company Admin, not Admins
  if (currentRole === 'company_admin') {
    return targetUserRole !== 'admin';
  }

  // Users cannot see any other user
  return false;
};

// Hook to check if user can promote to a specific role
export const useCanPromoteToRole = (targetRole: string) => {
  const currentRole = useCurrentUserRole();

  // Only Admins can promote to Admin
  if (targetRole === 'admin') {
    return currentRole === 'admin';
  }

  // Admin and Company Admin can promote to Company Admin
  if (targetRole === 'company_admin') {
    return currentRole === 'admin' || currentRole === 'company_admin';
  }

  // Admin and Company Admin can promote to User
  if (targetRole === 'customer') {
    return currentRole === 'admin' || currentRole === 'company_admin';
  }

  return false;
};
